import { render } from "./KryptonAlertPopin.vue?vue&type=template&id=2183ef6e&lang=pug"
import script from "./KryptonAlertPopin.vue?vue&type=script&lang=js"
export * from "./KryptonAlertPopin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__